import { jsxs as r, jsx as l } from "react/jsx-runtime";
const e = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M57.98 52.93V20.01l-26-14-26 14v34c0 2.21 1.79 4 4 4h45.07l-1.07-4h-44V22.4l22-11.85 22 11.85V54l4-1.07Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m35.68 45.14 9.34-9.34-9.36-9.36-3.35.9 6.97 6.96H19.16l.8 3h19.32l-6.95 6.95 3.35.89Z"
        }
      )
    ]
  }
);
export {
  e as HomeMove
};
